export type DeviceHints = {
  userAgent: string;
  screenWidth: number;
  screenHeight: number;
  hardwareConcurrency: number;
  deviceMemory?: number;
};

export function prefersConstrainedMemory(hints: DeviceHints) {
  const isIOS = /iPhone|iPad|iPod/i.test(hints.userAgent);
  const longEdge = Math.max(hints.screenWidth, hints.screenHeight);
  const lowMemory = typeof hints.deviceMemory === "number" && hints.deviceMemory <= 4;
  const lowConcurrency = hints.hardwareConcurrency > 0 && hints.hardwareConcurrency <= 2;

  // iPhone SE and the iPhone 6/7/8-sized class top out at 736 CSS pixels.
  // Keep the same ISNet model and output quality, but run it with a lower-peak
  // memory profile so Safari does not strand the worker during inference.
  return lowMemory || lowConcurrency || (isIOS && longEdge <= 736);
}

export function segmentationProfile(): "default" | "constrained" {
  const override = new URLSearchParams(window.location.search).get("memory");
  if (override === "default") return "default";
  if (override === "constrained") return "constrained";
  const navigatorWithMemory = navigator as Navigator & { deviceMemory?: number };
  return prefersConstrainedMemory({
    userAgent: navigator.userAgent,
    screenWidth: window.screen.width,
    screenHeight: window.screen.height,
    hardwareConcurrency: navigator.hardwareConcurrency || 0,
    deviceMemory: navigatorWithMemory.deviceMemory,
  })
    ? "constrained"
    : "default";
}
